import React from 'react';
import styled, { css } from 'styled-components';
import { useStyleElement } from 'gatsby-theme-core/src/layout/style-element';

// flex breaks the childrens min-height: 100vh, so force it to block

const Wrapper = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  main {
    flex-grow: 1;
  }

  ${({ $scrollSnap }) => $scrollSnap && css`
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      display: block;
      scroll-snap-type: y mandatory;
      overflow-y: auto;
      min-height: auto;
      height: 100vh;
      /* height: 100dvh; // this will make the page dance like crazy */
      > * {
        scroll-snap-align: center;
      }
    }
  `}
`;

const CoreWrapper = (props) => {
  const { scrollSnap } = useStyleElement();
  return (
    <Wrapper $scrollSnap={scrollSnap} {...props} />
  );
};

export default CoreWrapper;
